import React from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Breadcrumbs from '../../../../components/UI/Breadcrumbs';
import { translate } from '../../../../utils/util';
import ListSupplier from '../Supplier/ListSupplier';
import { ENUMS } from '../../../../utils/constants';

const PickingFilterBySupplier = (props) => {
    const titlePickingFilterBySupplier = { icon: "mdi mdi-dolly", label: translate('expedition:picking.title') };
    const subtitlesPickingFilterBySupplier = () => {
        return [{ icon: "mdi mdi-filter-variant", label: translate('expedition:picking.filterBySupplier') }];
    }

    return (
        <div>
            <Breadcrumbs id="pickingFilterBySupplier" title={titlePickingFilterBySupplier} subtitles={subtitlesPickingFilterBySupplier()} />
            <div className="container-fluid" style={{ marginTop: '40px', }}>
                <ListSupplier data={props} orderType={ENUMS.eOrderType.Picking.value} />
            </div>
        </div>
    );
};

export default withRouter((withTranslation()(PickingFilterBySupplier)));
